export const MAX_DECIMALS = 6;

export const MIN_VALUE = Number(
  `0.${Array(MAX_DECIMALS - 1)
    .fill(0)
    .join('')}1`,
);

export const MAX_BTN_CONTENT = `This value is calculated by subtracting the gas cost from your balance.`;

export const MAX_BTN_CONTENT_LOW_BALANCE = `${MAX_BTN_CONTENT} Currently, your balance is lower than the gas cost.`;

export const DEFAULT_QUOTE_REFETCH_INTERVAL = 20000;
